<script>
import { mapGetters, mapActions } from 'vuex';
import { format } from 'date-fns';

import CardsListItemContrat from './cards-list-item-contrat';

export default {
  name: 'Contrats',
  components: {
    CardsListItemContrat
  },

  data () {
    return {
      loading: true,
      modal: false,
      modalKey: 0,
      ligneContrat: null
    };
  },

  computed: {
    ...mapGetters({
      tiers: 'user/tiers',
      contrats: 'contrats/contrats'
    })
  },
  created () {
    const param = {
      typeTiers: this.tiers.typeTiers,
      numTiers: this.tiers.numTiers,
      numEntite: 'AGR',
      dateValidite: format(new Date(), 'yyyy-MM-dd')
    };

    this.loadContrats(param).finally(() => { this.loading = false; });
  },

  methods: {
    ...mapActions({
      loadContrats: 'contrats/loadContrats',
      addLineToCart: 'cart/addLine'
    }),

    commandeArticleContrat (ligne) {
      const infoLigne = {
        libelleArticle: ligne.libelleArticle,
        numArticle: ligne.numArticle,
        codeTypeArticle: ligne.codeTypeArticle,
        codeUniteArticle: 'T',
        numContrat: ligne.numContrat
      };

      this.ligneContrat = infoLigne;
      this.modal = true;
      this.modalKey++;
    },
    addToCart (ligne) {
      this.modal = false;
      this.addLineToCart(ligne);
      setTimeout(() => {
        this.$dialog.confirm({ text: '<i aria-hidden="true" style="font-size:42px;" class="v-icon notranslate mdi mdi-check-circle-outline theme--light"></i><br/>Le produit a été ajouté à votre panier', actions: { continuer: { text: 'Continuer mes achats ', flat: false }, panier: { text: 'Voir mon panier', color: 'primary', flat: false } } }).then(
          result => {
            if (result === 'panier') {
              this.$router.push({ name: 'main.catalog.cart' });
            }
          }
        );
      });
    },
    redirectionLotsPlans (ligne) {
      this.$router.push({ name: 'main.catalog.lots', query: { numBatiment: ligne.numBatiment, numLot: ligne.numLot } });
    }
  }
};
</script>
<template>
  <v-container fluid>
    <h2>
      Contrats
      <CardsHelp
        :page="'CONTRATS'"
        :niveau="'TITRE'"
      />
    </h2>

    <v-container fluid>
      <CardsList
        :items="contrats"
        :group-by="item=>item.contratFutur"
      >
        <template v-slot:empty>
          Aucun contrat.
        </template>

        <template v-slot:groupTitle="{group}">
          {{ group }}
        </template>

        <template v-slot:item="{item}">
          <CardsListItemContrat :ligne="item">
            <template v-slot:actions="{ligne}">
              <!-- <v-btn
                v-if="ligne.artCommandable && tiers.hasLots && ligne.codeFamilleArticle.startsWith('45')"
                color="secondary"
                outlined
                @click="redirectionLotsPlans(ligne)"
              >
                <span
                  v-if="!isMobile"
                  class="action-btn-text ml-1"
                >Lots &amp;<br>plans</span>
                <v-icon>$vuetify.icons.chicken</v-icon>
              </v-btn> -->
              <!-- <v-btn
                v-else
                class="action-btn"
                :disabled="!ligne.artCommandable"
                color="secondary"
                @click="commandeArticleContrat(ligne)"
              >
                <span
                  v-if="!isMobile"
                  class="action-btn-text"
                >Ajouter</span>
                <v-icon>
                  mdi-cart-outline
                </v-icon>
              </v-btn> -->
            </template>
          </CardsListItemContrat>
        </template>
      </CardsList>
    </v-container>
    <v-dialog
      v-model="modal"
      transition="dialog-bottom-transition"
      :fullscreen="isMobile"
      persistent
      scrollable
    >
      <LineEdit
        :key="modalKey"
        :line="ligneContrat"
        is-ajout
        @cancel="modal=false"
        @validate="addToCart"
      />
    </v-dialog>
    <Loader
      :loading="loading"
      dialog
    />
  </v-container>
</template>
